// Actions
export var OPEN_DIALOG = "OPEN_DIALOG";
export var CLOSE_DIALOG = "CLOSE_DIALOG"; // Statut initial

export var INITIAL_STATE = {
  /**
   * Objet de session sauvegardé dans le store
   * @category Dialogs
   * @typedef {object} ConfirmDialogObject
   * @property {boolean} [open=false] true pour ouvrir la boîte de dialogue, false pour la fermer
   * @property {string} [message=""] Message à afficher
   * @property {function} [onValid=() => { return; }] Fonction appelée après validation
   * @property {function} [onCancel=null] Fonction appelée après annulation
   */
  confirmDialog: {
    open: false,
    message: "",
    onValid: function onValid() {
      return;
    },
    onCancel: null
  }
};